import { useState } from "react";
import { Card, CardBody, Col, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { DismissPopoverTitle } from "../../../Constants/Constants";
import { DelayPopoverSubTitle } from "../../../Data/UiKits/Popover";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DismissPopover = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);

  return (
    <Col lg="4">
      <Card>
        <CommonCardHeader title={DismissPopoverTitle} span={DelayPopoverSubTitle} />
        <CardBody className="common-flex popover-wrapper">
          <Btn color="secondary" className="example-popover" id="DismissPopover" onClick={toggle}>
            {"Dismissible Popover"}
          </Btn>
          <Popover placement="right" isOpen={popover} target="DismissPopover" toggle={toggle}>
            <PopoverHeader>{"Dismissible Popover"}</PopoverHeader>
            <PopoverBody>{"And here's some amazing content. It's very engaging. Right?"}</PopoverBody>
          </Popover>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DismissPopover;
